import React from 'react';

import { Box } from '@chakra-ui/react';
import SkeletonLoader from 'components/SkeletonLoader';
import { StyledTypography } from 'styles/common';

export const DisplayInfo = ({ children, bgcolor = 'none' }) => (
  <Box width="100%" padding="2rem" display="flex" justifyContent="center" bgColor={bgcolor}>
    {children}
  </Box>
);

export const showLoader = (bgcolor = 'none') => (
  <DisplayInfo bgcolor={bgcolor}>
    <SkeletonLoader skeletons={['100%', '100%']} />
  </DisplayInfo>
);

export const showNoData = ({ infoText }) => (
  <DisplayInfo>
    <StyledTypography variant="body1">{infoText}</StyledTypography>
  </DisplayInfo>
);

export const showErrorMessage = ({ errorText }) => (
  <DisplayInfo>
    <StyledTypography variant="body1" color="red">
      {errorText}
    </StyledTypography>
  </DisplayInfo>
);
